import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import blogReducer from './slices/blog';
import userReducer from './slices/user';
import productReducer from './slices/product';
import authJwtReducer from './slices/authJwt';
import settingsReducer from './slices/settings';
import calendarReducer from './slices/calendar';
import clientReducer from './slices/client';
import adminReducer from './slices/admin';
import csvReducer from './slices/csvupload';
import linkReducer from './slices/link';
import snackbarReducer from './slices/snackbar';
import endpointReducer from './slices/endpoint';
import cadenceReducer from './slices/cadence';
import subaccountReducer from './slices/subaccount';
import managementReducer from './slices/management';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['settings']
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

const authPersistConfig = {
  key: 'authJwt',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['isAuthenticated']
};

const rootReducer = combineReducers({
  snackbar: snackbarReducer,
  mail: mailReducer,
  chat: chatReducer,
  blog: blogReducer,
  user: userReducer,
  settings: settingsReducer,
  calendar: calendarReducer,
  client: clientReducer,
  admin: adminReducer,
  csv: csvReducer,
  product: persistReducer(productPersistConfig, productReducer),
  authJwt: persistReducer(authPersistConfig, authJwtReducer),
  link: linkReducer,
  endpoint: endpointReducer,
  cadence: cadenceReducer,
  subaccount: subaccountReducer,
  management: managementReducer
});

export { rootPersistConfig, rootReducer };
